(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-value-proposition"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#pp-root .pp-review-link');
    const reviews = document.getElementById('judgeme_all_reviews_page');
    if (!link || !reviews) return;
    event.preventDefault();
    event.stopPropagation();
    reviews.setAttribute('tabindex', '-1');
    reviews.focus({ preventScroll: true });
    reviews.scrollIntoView({ behavior: 'auto', block: 'start' });
  }, true);
  } catch(e) { console.error(e); }
})();

})();
